<template>
	<v-toolbar-items>
          <v-btn flat="flat" to="/login">
            {{this.$store.getters["translate/translater"]
              .__("Login", "users")}}
          </v-btn>
          
        </v-toolbar-items>
</template>

<script>
	export default {
		name: 'Guest'
	}
</script>